import { Route, Routes } from 'react-router-dom'
import { usePermissions } from '@/shared/hooks/usePermissions'
import InstallationCreatePage from './installation-create'
import ProductionRoutes from '@/features/production-routes/pages'
import Materials from '@/features/materials'
import NoAccess from '@/features/auth/pages/NoAccess'

export default function Installations() {
  const { checkPermission } = usePermissions()

  const canCreateInstallation = checkPermission('installation', 'create')
  const localStorageInstallationKey = 'installation-creation-state'

  return (
    <>
      <Routes>
        {canCreateInstallation ? (
          <Route path="/new">
            <Route
              index
              path="*"
              element={<InstallationCreatePage localStorageKey={localStorageInstallationKey} />}
            />
          </Route>
        ) : (
          <Route path="/new">
            <Route index path="*" element={<NoAccess />} />
          </Route>
        )}
        <Route path="/:installationId/production-routes">
          <Route index path="*" element={<ProductionRoutes />} />
        </Route>
        <Route path="/:installationId/materials">
          <Route index path="*" element={<Materials />} />
        </Route>
      </Routes>
    </>
  )
}
